import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_CONTROLROOMS_API || 'https://api.dev.controlrooms.ai';

// Create axios instance with base configuration
const api = axios.create({
  baseURL: '/api/v1/jobs',  // This will be proxied by nginx
  timeout: 5000,
});

// Add response interceptor for error handling
api.interceptors.response.use(
  response => response,
  error => {
    console.error('API Error:', {
      url: error.config?.url,
      status: error.response?.status,
      message: error.message,
      response: error.response?.data
    });
    throw error;
  }
);

export const fetchHistoricalData = async (plantId, materialNumber, token, authHeaders = {}) => {
  try {
    const headers = {
      'X-Plant-ID': plantId,
      ...authHeaders
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    const response = await axios.get(`${API_BASE_URL}/api/v1/historical-data`, {
      headers,
      params: {
        plant_id: plantId,
        materialNumber
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching historical data:', error);
    throw error;
  }
};

export const fetchProcessOrder = async (plantId, orderNumber, token, authHeaders = {}) => {
  try {
    const headers = {
      'X-Plant-ID': plantId,
      ...authHeaders
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    const response = await axios.get(`${API_BASE_URL}/api/v1/jobs/history/${orderNumber}`, {
      headers,
      params: {
        plant_id: plantId
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching process order:', error);
    throw error;
  }
};

export const fetchGradeHistory = async (plantId, gradeNumber, token, authHeaders = {}) => {
  try {
    const headers = {
      'X-Plant-ID': plantId,
      ...authHeaders
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    const params = {
      plant_id: plantId,
      grade: gradeNumber,
      in_spec: true  // Only fetch in-spec jobs for production
    };
    const response = await axios.get(`${API_BASE_URL}/api/v1/jobs/history`, {
      headers,
      params
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching grade history:', error);
    throw error;
  }
};

export const fetchSliderMetrics = async (plantId, token, authHeaders = {}) => {
  if (!plantId) {
    return [];
  }
  const response = await fetch(`/api/v1/jobs/history/ranges?plant_id=${plantId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      ...authHeaders
    },
  });
  if (!response.ok) {
    const errorData = await response.text();
    console.error('[historyService] fetchSliderMetrics error:', response.status, errorData);
    throw new Error(`Failed to fetch slider metrics: ${response.status} ${errorData}`);
  }
  const data = await response.json();
  return data.metrics || []; // The endpoint returns { plant_id: "...", metrics: [...] }
}; 